/* ─── Fullscreen toggle for native hero videos ───
   Wired to any [data-video-fullscreen] button. On click, fullscreens the
   associated <video> and temporarily enables native controls while fullscreen
   (so the user can pause / scrub / exit like YouTube). Esc (or the button
   again) exits and controls are removed again. Used by the homepage hero video
   and the product hero (native) videos. Guarded so loading twice is harmless. */
(function () {
  if (window.__irVideoFullscreenBound) return;
  window.__irVideoFullscreenBound = true;

  function getNativeVideo(btn) {
    var scope = btn.closest('.ir-product-video__wrapper, .ir-video-container') || btn.parentElement;
    if (!scope) return null;
    var v = scope.querySelector('video');
    return v || null;
  }

  function isFullscreen() {
    return !!(document.fullscreenElement || document.webkitFullscreenElement || document.webkitCurrentFullScreenElement);
  }

  function exitFullscreen() {
    if (document.exitFullscreen) document.exitFullscreen();
    else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
    else if (document.webkitCancelFullScreen) document.webkitCancelFullScreen();
  }

  function enterFullscreen(video) {
    // Show native controls while fullscreen (pause/scrub/exit) — removed on exit
    video.setAttribute('controls', '');
    var done = function () {
      if (!isFullscreen()) {
        video.removeAttribute('controls');
        document.removeEventListener('fullscreenchange', done);
        document.removeEventListener('webkitfullscreenchange', done);
        document.removeEventListener('webkitcurrentfullscreenchange', done);
      }
    };
    document.addEventListener('fullscreenchange', done);
    document.addEventListener('webkitfullscreenchange', done);

    var rv = null;
    if (video.requestFullscreen) rv = video.requestFullscreen();
    else if (video.webkitRequestFullscreen) video.webkitRequestFullscreen();
    else if (video.webkitEnterFullscreen) video.webkitEnterFullscreen(); // iOS Safari
    else if (video.webkitEnterFullScreen) video.webkitEnterFullScreen();
    else { video.removeAttribute('controls'); return; }

    if (rv && rv.catch) rv.catch(function () { video.removeAttribute('controls'); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-video-fullscreen]');
    if (!btn) return;
    var video = getNativeVideo(btn);
    if (!video) return;
    e.preventDefault();
    if (isFullscreen()) exitFullscreen();
    else enterFullscreen(video);
  });
})();
